import * as z from 'zod';

export const courierTransactionSchema = z
  .object({
    id: z.union([z.string(), z.number()]),
    display_id: z.union([z.string(), z.number()]).nullish(),
    type: z.coerce.number(),
    status: z.coerce.number(),
    amount: z.coerce.number(),
    prev_balance: z.coerce.number().nullish(),
    after_balance: z.coerce.number().nullish(),
    created_at: z.string().nullish(),
    performed_at: z.string().nullish(),
    order: z
      .object({
        id: z.union([z.string(), z.number()]),
        display_id: z.union([z.string(), z.number()]).nullish(),
      })
      .nullish(),
  })
  .loose();

export const courierTransactionsSchema = z.object({
  data: z.array(courierTransactionSchema),
  count: z.coerce.number().int().nonnegative(),
  stats: z
    .object({
      in_sum: z.coerce.number().default(0),
      out_sum: z.coerce.number().default(0),
    })
    .default({ in_sum: 0, out_sum: 0 }),
});

const dateSchema = z.iso.date().optional().catch(undefined);
export const courierTransactionsSearchSchema = z.object({
  txPage: z.coerce.number().int().positive().catch(1).default(1),
  txPageSize: z.coerce.number().int().min(1).max(100).catch(10).default(10),
  txType: z.coerce.number().int().min(1).max(18).optional().catch(undefined),
  txStatus: z.coerce.number().int().min(1).max(4).optional().catch(undefined),
  txFrom: dateSchema,
  txTill: dateSchema,
});

export type CourierTransaction = z.infer<typeof courierTransactionSchema>;
export type CourierTransactions = z.infer<typeof courierTransactionsSchema>;
export type CourierTransactionsSearch = z.infer<typeof courierTransactionsSearchSchema>;

// Numeric codes from cpanel/assets/data/transaction-types.ts.
export const COURIER_TRANSACTION_TYPES = Array.from({ length: 18 }, (_, i) => i + 1);
export const COURIER_TRANSACTION_STATUSES = [1, 2, 3, 4] as const;
export function canCancelCourierTransaction(row: CourierTransaction): boolean {
  return (row.type === 5 || row.type === 9) && row.status === 1;
}
